export default __webpack_public_path__ + "locales/ar-SA/InviteDialog.json?hash=af7ab2daa5ab694e4148fb93ff351fd1";